var map = {
	"./02_hero_desktop.jpg": 242,
	"./02_hero_mobile.jpg": 243,
	"./02_hero_tablet.jpg": 244,
	"./04_hero_desktop.jpg": 245,
	"./04_hero_mobile.jpg": 246,
	"./04_hero_tablet.jpg": 247,
	"./06_hero_desktop.jpg": 248,
	"./06_hero_mobile.jpg": 249,
	"./06_hero_tablet.jpg": 250,
	"./07_hero_desktop.jpg": 251,
	"./07_hero_mobile.jpg": 252,
	"./07_hero_tablet.jpg": 253,
	"./08_hero_desktop.jpg": 254,
	"./08_hero_mobile.jpg": 255,
	"./08_hero_tablet.jpg": 256,
	"./10_hero_desktop.jpg": 257,
	"./10_hero_mobile.jpg": 258,
	"./10_hero_tablet.jpg": 259,
	"./11b_hero_desktop.jpg": 260,
	"./11b_hero_mobile.jpg": 261,
	"./11b_hero_tablet.jpg": 262,
	"./12b_hero_desktop.jpg": 263,
	"./12b_hero_mobile.jpg": 264,
	"./12b_hero_tablet.jpg": 265,
	"./Corteva_Do_More_with_Less.jpg": 266,
	"./Corteva_From_Data_to_Decision.jpg": 267,
	"./Tanzania-Queen-and-Son-small.jpg": 268,
	"./Thailand.jpg": 269,
	"./artOfPrecision-desktop.jpg": 270,
	"./brazil_old_pastures.jpg": 271,
	"./cracking-the-code.jpg": 272,
	"./farmingWithNoRain-desktop.jpg": 273,
	"./foodByPrescription-desktop.jpg": 274,
	"./howTheWorldGrow-desktop.jpg": 275,
	"./seeds-of-change-desktop.jpg": 276,
	"./silicon-farm-thumbnail.jpg": 277
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 521;